module.exports = __webpack_public_path__ + "img/step2.6e0ddcdb.png";